import { useState } from 'react';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';
import { Box, Button, Stack, Typography } from '@mui/material';
import { ContentBox } from '@/components/shared/content-box';
import { InfoCard } from '@/components/shared/info-card';
import { useRecommendationProfile } from '@/context/recommendation-profile';
import { EditOccupationsDialog } from '@/packages/skill-management/components/occupations/edit-occupations-dialog';
import { Skeleton } from '@/packages/skill-management/components/skeleton';
import { SkillsList } from '@/packages/skill-management/components/skills-list';
import { UpdateSkillsDialog } from '@/packages/skill-management/components/update-skills-dialog';
import { useSkills } from '@/packages/skill-management/context/skills';
import { lineClamp } from '@/utils/line-clamp';
import { profileGoalDescription } from '@/utils/profile-goal-description';

const INFO_MISSING_MESSAGE = 'Não informado';

export const Occupations = () => {
  const [updateSkillsDialogOpen, setUpdateSkillsDialogOpen] = useState(false);
  const [editObjectiveAndJobDialogOpen, setEditObjectiveAndJobDialogOpen] =
    useState(false);
  const {
    userOccupationSkills,
    jobs,
    isLoadingJobs,
    refetchJobs,
    refetchSelectedSkills,
  } = useSkills();
  const { profile } = useRecommendationProfile();
  const checkedSkills = userOccupationSkills?.filter((skill) => skill.checked);
  const uncheckedSkills =
    userOccupationSkills?.filter((skill) => !skill.checked) || [];

  const currentJobLabel =
    jobs?.current?.name || profile?.current_job?.name || INFO_MISSING_MESSAGE;

  if (isLoadingJobs) return <Skeleton />;

  const openEditObjectiveAndOccupationDialog = () => {
    setEditObjectiveAndJobDialogOpen(true);
  };

  return (
    <>
      <ContentBox
        direction={{ md: 'row' }}
        alignItems="start"
        gap={{ xs: 3, md: 6 }}
      >
        <Stack flex={1} spacing={2} alignItems="start" width="100%">
          <InfoCard
            withBorder
            icon={AssignmentIndOutlinedIcon}
            onClick={openEditObjectiveAndOccupationDialog}
          >
            <Typography variant="h3">Cargo atual</Typography>
            <Typography sx={lineClamp(1)}>{currentJobLabel}</Typography>
          </InfoCard>
          <InfoCard
            withBorder
            icon={CenterFocusStrongIcon}
            onClick={openEditObjectiveAndOccupationDialog}
          >
            <Typography variant="h3">Objetivo de desenvolvimento</Typography>
            <Typography sx={lineClamp(1)}>
              {profile && profileGoalDescription(profile, jobs)}
            </Typography>
          </InfoCard>
          <Button onClick={openEditObjectiveAndOccupationDialog}>
            Alterar cargo
          </Button>
        </Stack>
        <Stack flex={1} alignItems="start" spacing={2}>
          <Typography variant="h3">Habilidades em foco</Typography>
          <Box>
            <SkillsList
              onClick={() => setUpdateSkillsDialogOpen(true)}
              checkedSkills={checkedSkills ?? []}
              uncheckedSkills={uncheckedSkills}
            />
          </Box>
          <Button onClick={() => setUpdateSkillsDialogOpen(true)}>
            Editar habilidades
          </Button>
        </Stack>
      </ContentBox>
      {updateSkillsDialogOpen && (
        <UpdateSkillsDialog
          skills={userOccupationSkills ?? []}
          onClose={() => setUpdateSkillsDialogOpen(false)}
        />
      )}
      {editObjectiveAndJobDialogOpen && (
        <EditOccupationsDialog
          onSuccess={async () => {
            await refetchJobs?.();
            await refetchSelectedSkills?.();
            setUpdateSkillsDialogOpen(true);
            setEditObjectiveAndJobDialogOpen(false);
          }}
          onClose={() => setEditObjectiveAndJobDialogOpen(false)}
        />
      )}
    </>
  );
};
